import React from 'react'

export default function Loading() {
  return (
    <div className="relative w-full h-1 bg-background">
      <div className="absolute h-1 bg-primary-orange animate-loading w-full"></div>
    </div>
  )
}
